var colorSlide = document.querySelector('.collection__nav__banner-slide');

if (colorSlide) {
  const swiper = new Swiper('.collection__nav__banner-slide', {
    slidesPerView: 5.5,
    spaceBetween: 5,
    breakpoints: {
      480: {
        slidesPerView: 5.5,
        spaceBetween: 8,
      },
      990: {
        slidesPerView: 6.5,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 9,
        spaceBetween: 10,
      },
      1400: {
        slidesPerView: 9,
        spaceBetween: 10,
      }
    },
  });
}
